export default __webpack_public_path__ + "static/media/icon.32a3c52d.svg";